import * as React from 'react';
import { connect } from 'react-redux';

import KeyActivity from '../KeyActivity/KeyActivity';
import * as ActivityCreators from '../../creators/activityMountTab';
import * as UserExplorerActions from '../../actions/userExplorer';
import { currentProductLabel$ } from '../../selectors/product';
import UserExplorer from '../UserExplorer/UserExplorer';

import State from '../../interfaces/states/State';
import DatesAnyArray from '../../interfaces/DatesAnyArray';

import './style.scss';

interface DispatchProps {
  activityMountTab: () => void;
  userExplorerInit: () => void;
}

interface OwnProps {
  activityData: DatesAnyArray;
  isLoading: boolean;
  currentProductLabel: string;
}

interface Props extends DispatchProps, OwnProps {}

function Activity (props: Props) {

  React.useEffect(() => {
    props.userExplorerInit();
    props.activityMountTab();
  }, []);
   
  const {
    currentProductLabel,
    activityData,
    isLoading,
  } = props;
  
  return(
    <section className='activity-container d-flex'>
      <KeyActivity
        currentProductLabel={currentProductLabel}
        activityData={activityData}
        isLoading={isLoading} />
      <UserExplorer />
    </section>
  );
}

const mapStateToProps = (state: State) => {
  return {
    currentProductLabel: currentProductLabel$(state),
    activityData: state.activity.activityData,
    isLoading: state.activity.isLoading,
  };
};

const mergeProps = (stateProps, dispatchProps: DispatchProps, props: OwnProps): Props => {
  return {
    ...stateProps,
    activityMountTab: dispatchProps.activityMountTab,
    userExplorerInit: dispatchProps.userExplorerInit,
    ...props,
  };
};

export default connect(
  mapStateToProps, {
    activityMountTab: ActivityCreators.activityMountTab,
    userExplorerInit: UserExplorerActions.fetchUserExplorerInitAction,
  }, mergeProps
)(React.memo(Activity));
